import { render, staticRenderFns } from "./CreateKokubanFolder.vue?vue&type=template&id=0f8ea112&scoped=true&"
import script from "./CreateKokubanFolder.vue?vue&type=script&lang=js&"
export * from "./CreateKokubanFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8ea112",
  null
  
)

export default component.exports